/**
 * Per-question response distribution bars for Lumyn Live host.
 *
 * Extracted verbatim from LiveHostPage.jsx during the Phase 2 refactor
 * (no behaviour change).
 */
export function DistributionBars({ distribution }) {
  if (!distribution) return null;
  const total = distribution.total_answered || 0;
  return (
    <div className="space-y-2" data-testid={`dist-q${distribution.question_index}`}>
      <div className="flex items-baseline gap-3 text-xs">
        <span className="font-medium">
          Question {distribution.question_index + 1}
        </span>
        <span className="text-muted-foreground truncate flex-1">
          {distribution.question_text}
        </span>
        <span className="text-muted-foreground tabular-nums">
          {distribution.correct_count}/{total} correct
        </span>
      </div>
      <div className="space-y-1">
        {(distribution.option_counts || []).map((o, i) => {
          const pct = total > 0 ? (o.count / total) * 100 : 0;
          return (
            <div key={o.option_id || i} className="flex items-center gap-2 text-xs">
              <span className="w-4 font-mono text-muted-foreground">
                {String.fromCharCode(65 + i)}
              </span>
              <span className="flex-1 truncate">{o.text}</span>
              <div className="w-32 sm:w-48 h-2 bg-white/10 rounded-full overflow-hidden">
                <div
                  className={`h-full transition-all ${o.is_correct ? 'bg-[var(--lumyn-success)]' : 'bg-[var(--lumyn-live)]'}`}
                  style={{ width: `${pct}%` }}
                />
              </div>
              <span className="w-12 text-right tabular-nums text-muted-foreground">
                {o.count} · {Math.round(pct)}%
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
